document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('global-header');
    if (!header) return;
  const mobileHeader = document.getElementById('mobile-header-bar');

  // Search modal
  const searchModal = document.getElementById('search-modal');
  const searchOpenButtons = document.querySelectorAll('.search-label-button');

  if (searchModal && searchOpenButtons.length) {
    const backdrop = searchModal.querySelector('.search-modal-backdrop');
    const closeEls = searchModal.querySelectorAll('[data-search-close]');

    function getSearchInput() {
      return (
        searchModal.querySelector('.search-input') ||
        searchModal.querySelector('.ps__input')
      );
    }

    function openSearchModal(btn) {
      searchModal.classList.add('is-open');
      searchModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');

      const input = getSearchInput();
      if (input) {
        setTimeout(() => input.focus(), 50);
      }
    }

    function closeSearchModal() {
      searchModal.classList.remove('is-open');
      searchModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    searchOpenButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openSearchModal(btn);
      });
    });

    closeEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSearchModal();
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', (e) => {
        e.preventDefault();
        closeSearchModal();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('is-open')) {
        closeSearchModal();
      }
    });
  }
  
    const dropdownItems = header.querySelectorAll('.has-dropdown');
    const dropdownContainer = document.getElementById('dropdown-container');
    const dropdownMenu = dropdownContainer.querySelector('.dropdown-menu');
  
    let dropdownTimeout;
    let dropdownEnterTimeout;
    let currentOpenDropdown = null;
    let isDropdownOpen = false;
  
    const originalDropdowns = {};
  
    dropdownItems.forEach((item) => {
      const dropdownTrigger = item.querySelector('.dropdown-trigger');
  
      if (dropdownTrigger) {
        const dropdownType = dropdownTrigger.getAttribute('data-dropdown');
        const originalMenu = item.querySelector('.dropdown-menu');
  
        if (originalMenu) {
          originalDropdowns[dropdownType] = originalMenu.innerHTML;
        }
      }
    });
  
    function updateDropdownContent(type) {
      if (originalDropdowns[type]) {
        const dropdownColumns = dropdownMenu.querySelector('.dropdown-columns');
  
        if (dropdownColumns) {
          dropdownColumns.style.opacity = '0';
  
          setTimeout(() => {
            dropdownMenu.innerHTML = originalDropdowns[type];
  
            const newDropdownColumns = dropdownMenu.querySelector('.dropdown-columns');
            if (newDropdownColumns) {
              newDropdownColumns.style.opacity = '1';
            }
          }, 150);
        }
      }
    }
  
    function openDropdown(item, dropdownType) {
      if (currentOpenDropdown && currentOpenDropdown !== item) {
        updateDropdownContent(dropdownType);
      } else {
        dropdownMenu.innerHTML = originalDropdowns[dropdownType];
  
        const dropdownColumns = dropdownMenu.querySelector('.dropdown-columns');
        if (dropdownColumns) {
          dropdownColumns.style.opacity = '1';
        }
      }
  
      dropdownMenu.classList.add('active');
      header.classList.add('invert');
  
      currentOpenDropdown = item;
      isDropdownOpen = true;
  
      item.classList.add('is-open');
    }
  
    function closeDropdown() {
      dropdownMenu.classList.remove('active');
      header.classList.remove('invert');
  
      currentOpenDropdown = null;
      isDropdownOpen = false;
  
      dropdownItems.forEach((item) => item.classList.remove('is-open'));
    }
  
    dropdownItems.forEach((item) => {
      const dropdownTrigger = item.querySelector('.dropdown-trigger');
      if (!dropdownTrigger) return;
  
      const dropdownType = dropdownTrigger.getAttribute('data-dropdown');
  
      dropdownTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openDropdown(item, dropdownType);
      });
  
      item.addEventListener('mouseenter', () => {
        clearTimeout(dropdownTimeout);
        clearTimeout(dropdownEnterTimeout);
  
        dropdownEnterTimeout = setTimeout(() => {
          openDropdown(item, dropdownType);
        }, 100);
      });
  
      item.addEventListener('mouseleave', (e) => {
        clearTimeout(dropdownEnterTimeout);
  
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && (relatedTarget === dropdownMenu || dropdownMenu.contains(relatedTarget))) {
          return;
        }
  
        dropdownTimeout = setTimeout(() => {
          closeDropdown();
        }, 250);
      });
    });
  
    dropdownMenu.addEventListener('mouseenter', () => {
      clearTimeout(dropdownTimeout);
    });
  
    dropdownMenu.addEventListener('mouseleave', (e) => {
      const relatedTarget = e.relatedTarget;
  
      if (relatedTarget && relatedTarget.closest('.has-dropdown')) {
        return;
      }
  
      dropdownTimeout = setTimeout(() => {
        closeDropdown();
      }, 250);
    });
  
    document.addEventListener('click', (e) => {
      if (
        isDropdownOpen &&
        !e.target.closest('.has-dropdown') &&
        !e.target.closest('.dropdown-container')
      ) {
        closeDropdown();
      }
    });
  
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDropdownOpen) {
        closeDropdown();
      }
    });
  
    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
    const mobileNavClose = document.querySelector('.mobile-nav-close');
  
    function toggleMobileNav() {
        const isActive = mobileNavOverlay.classList.contains('active');
      
        if (isActive) {
          mobileNavOverlay.classList.remove('active');
          mobileNavOverlay.setAttribute('aria-hidden', 'true');
          mobileNavToggle.setAttribute('aria-expanded', 'false');
          mobileNavToggle.innerHTML = `
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
      
          document.body.classList.remove('overflow-hidden');
          mobileNavToggle.focus();
        } else {
          mobileNavOverlay.classList.add('active');
          mobileNavOverlay.setAttribute('aria-hidden', 'false');
          mobileNavToggle.setAttribute('aria-expanded', 'true');
          mobileNavToggle.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <line x1="20" y1="4" x2="4" y2="20"></line>
              <line x1="4" y1="4" x2="20" y2="20"></line>
            </svg>
          `;
      
          document.body.classList.add('overflow-hidden');
      
          const firstLink = mobileNavOverlay.querySelector('.mobile-nav-link');
          if (firstLink) firstLink.focus();
        }
      }
  
    if (mobileNavToggle) {
      mobileNavToggle.addEventListener('click', toggleMobileNav);
    }
  
    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', toggleMobileNav);
    }
  
    // if (mobileNavOverlay) {
    //   mobileNavOverlay.addEventListener('click', function (e) {
    //     if (e.target === mobileNavOverlay) {
    //       closeMobileNav();
    //     }
    //   });
    // }
  
    // document.addEventListener('keydown', function (e) {
    //   if (e.key === 'Escape' && mobileNavOverlay.classList.contains('active')) {
    //     closeMobileNav();
    //   }
    // });
  
    mobileNavOverlay &&
      mobileNavOverlay.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          const focusableEls = mobileNavOverlay.querySelectorAll(
            'a, button, [tabindex]:not([tabindex="-1"])'
          );
  
          const firstEl = focusableEls[0];
          const lastEl = focusableEls[focusableEls.length - 1];
  
          if (e.shiftKey) {
            if (document.activeElement === firstEl) {
              e.preventDefault();
              lastEl.focus();
            }
          } else {
            if (document.activeElement === lastEl) {
              e.preventDefault();
              firstEl.focus();
            }
          }
        }
      });
  
    const mobileSearchRow = document.querySelector('.mobile-search-row');
    const mobileSearchLabel = document.querySelector('.mobile-search-label');
    const mobileSearchForm = document.querySelector('.mobile-search-form');
    const mobileSearchInput = document.querySelector('.mobile-search-input');
    const mobileSearchClose = document.querySelector('.mobile-search-close');
    const mobileNavList = document.querySelector('.mobile-nav-list');
  
    if (mobileSearchLabel && mobileSearchForm && mobileSearchInput) {
      mobileSearchLabel.addEventListener('click', function () {
        mobileSearchForm.classList.add('active');
        mobileSearchInput.focus();
      });
    }
  
    if (mobileSearchClose && mobileSearchForm && mobileSearchLabel) {
      mobileSearchClose.addEventListener('click', function () {
        mobileSearchForm.classList.remove('active');
        mobileSearchLabel.focus();
      });
    }
  });
  
  document.addEventListener('click', function (e) {
    const cartLink = e.target.closest('.js-cart-link, .header-cart');
    const cartDrawer = document.querySelector('.cart-drawer');
  
    if (cartLink && cartDrawer) {
      e.preventDefault();
      cartDrawer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
  
      const closeBtn = cartDrawer.querySelector('.cart-drawer__close-link, .cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }
  });
  
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.cart-drawer__close-link, .cart-drawer__close');
    const cartDrawer = document.querySelector('.cart-drawer');
  
    if (closeBtn && cartDrawer) {
      e.preventDefault();
      cartDrawer.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }
  });